module.exports = __webpack_public_path__ + "static/media/m_sf_2.f2ab1d42.png";